import { getCurrentInstance } from 'vue'
import { useApi } from '@/apps/shared/composables'
import { useMainStore } from '../stores/main'

export const useSendMessage = emitter => {
  const store = useMainStore()
  const api = useApi()
  const instance = getCurrentInstance().root

  return async (view = null) => {
    const { data: conversationData } = await api.post('/api/conversations', {
      conversation: { recipient_id: instance.root.data.designerId, from_fast_contact: true }
    })
    store.conversation = conversationData.conversation
    await api.post(`/api/conversation_messages`, {
      conversation_id: conversationData.conversation.id,
      conversation_message: { body: store.form.content }
    })
    emitter(
      'goto',
      view !== 'signup' && (store.loggedUser?.confirmed_at || (!store.loggedUser && instance.root.data.currentUserConfirmed))
        ? 'success'
        : 'confirmation'
    )
  }
}
